"use client";
import React from "react";
import NoData from "@/components/client/NoData";
import { useMatchData } from '@/hooks/useMatchData';
import LoadingInner from "@/app/loadingInner";

const StatisticListComponent = (props) => {
  const { period } = props;
  const STATISTICS_MAPPING = [
    { type: 0, name: "Giao bóng" },
    { type: 1, name: "Phạt góc đầu tiên" },
    { type: 2, name: "Thẻ vàng đầu tiên" },
    { type: 3, name: "Sút bóng" },
    { type: 4, name: "Sút trúng đích" },
    { type: 5, name: "Phạm lỗi" },
    { type: 6, name: "Phạt góc" },
    { type: 7, name: "Phạt góc bù giờ" },
    { type: 8, name: "Đá phạt" },
    { type: 9, name: "Việt vị" },
    { type: 10, name: "Phản lưới nhà" },
    { type: 11, name: "Thẻ vàng" },
    { type: 12, name: "Thẻ vàng bù giờ" },
    { type: 13, name: "Thẻ đỏ" },
    { type: 14, name: "Kiểm soát bóng" },
    { type: 15, name: "Không chiến" },
    { type: 16, name: "Cản phá" },
    { type: 17, name: "Thủ môn băng ra" },
    { type: 18, name: "Mất bóng" },
    { type: 19, name: "Tắc bóng thành công" },
    { type: 20, name: "Cắt bóng" },
    { type: 21, name: "Chuyền dài" },
    { type: 22, name: "Chuyền ngắn" },
    { type: 23, name: "Kiến tạo" },
    { type: 24, name: "Tạt bóng thành công" },
    { type: 25, name: "Thay người đầu tiên" },
    { type: 26, name: "Thay người cuối cùng" },
    { type: 27, name: "Việt vị đầu tiên" },
    { type: 28, name: "Việt vị cuối cùng" },
    { type: 29, name: "Thay người" },
    { type: 30, name: "Phạt góc cuối cùng" },
    { type: 31, name: "Thẻ vàng cuối cùng" },
    { type: 32, name: "Thay người bù giờ" },
    { type: 33, name: "Việt vị bù giờ" },
    { type: 34, name: "Sút không trúng đích" },
    { type: 35, name: "Sút trúng cột dọc" },
    { type: 36, name: "Đánh đầu thành công" },
    { type: 37, name: "Bị chặn" },
    { type: 38, name: "Tắc bóng" },
    { type: 39, name: "Dốc bóng" },
    { type: 40, name: "Ném biên" },
    { type: 41, name: "Chuyền bóng" },
    { type: 42, name: "Chuyền chính xác" },
    { type: 43, name: "Tấn công" },
    { type: 44, name: "Tấn công nguy hiểm" },
    { type: 45, name: "Phạt góc hiệp một" },
    { type: 46, name: "Kiểm soát bóng hiệp một" },
    { type: 47, name: "Cản phá phạt đền" },
  ];

  return period?.map((el) => {
    let totalPoint, homePercent, awayPercent;

    if (isNaN(el.home) || isNaN(el.away)) {
      if (el.home === "*" || el.away === "*") {
        if (el.home === "*") {
          homePercent = "100%";
          awayPercent = "0%";
        } else {
          homePercent = "0%";
          awayPercent = "100%";
        }
      } else {
        homePercent = el.home;
        awayPercent = el.away;
      }
    } else {
      totalPoint = +(+el.home + +el.away);

      if (totalPoint != 0) {
        homePercent = Math.round((el.home / totalPoint) * 100);
        awayPercent = 100 - homePercent;
      } else {
        homePercent = 0;
        awayPercent = 0;
      }

      homePercent += "%";
      awayPercent += "%";
    }

    const statisticName = STATISTICS_MAPPING.find(
      (item) => item.type === el.type
    ).name;

    return (
      <StatisticComponent
        title={statisticName}
        homePercent={homePercent}
        home={el.home}
        awayPercent={awayPercent}
        away={el.away}
      />
    );
  });
};

const StatisticComponent = (props) => {
  const { title, homePercent, awayPercent, home, away } = props;
  const homeBg =
    homePercent > awayPercent
      ? "bg-gradient-start"
      : homePercent < awayPercent
      ? "bg-button-blue-bet dark:bg-large-blue"
      : "bg-gradient-start";
  const awayBg =
    awayPercent > homePercent
      ? "bg-gradient-start"
      : awayPercent < homePercent
      ? "bg-button-blue-bet dark:bg-large-blue"
      : "bg-gradient-start";

  const homePercentHtml = `<div class="bg ${homeBg}" style="width: ${homePercent}"></div>`;
  const awayPercentHtml = `<div class="bg ${awayBg}" style="width: ${awayPercent}"></div>`;

  const capitalizeWord = (value) => {
    if (!value) {
      return ""
    }

    const words = value.split(" ");

    return words.map((word) => { 
        return word[0].toUpperCase() + word.substring(1); 
    }).join(" ");
  }

  return (
    <div>
      <div class="statistic__element">
        <div class="statistic__wrapper">
          <div class="statistic__values ot-text text-dark dark:text-stroke-o3">
            <div class="home__value">{home}</div>
            <div class="statistic__title text-dark-gray dark:bg-black dark:text-stroke-o3">{capitalizeWord(title)}</div>
            <div class="away__value">{away}</div>
          </div>
          <div
            class={`statistic__charts bg-white dark:bg-league-gray-dark`}
          >
            <div
              class="chart home__chart"
              dangerouslySetInnerHTML={{ __html: homePercentHtml }} 
            ></div>
            <div class="statistic__title text-dark-gray dark:bg-black dark:text-stroke-o3">{capitalizeWord(title)}</div>
            <div
              class="chart away__chart"
              dangerouslySetInnerHTML={{ __html: awayPercentHtml }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LiveStats = ({ stats, matchId }) => {
  const {statsLive, matchLive, loading } = useMatchData(matchId);
  const status = matchLive?.status;
  const isLive = [1,2,3,4,5].includes(status);

  let statsResult = matchLive?.stats?.length > 0
      ? matchLive.stats
      : [];

  if ([1,2,3,4,5].includes(status)) {
    statsResult = statsLive?.stats?.length > 0 ? statsLive.stats : statsResult;
  }
  
  return loading && !isLive ? (<LoadingInner/>) : (statsResult?.length ? (<StatisticListComponent period={statsResult} />) : (<NoData message="Không có dữ liệu"/>));
};

export default React.memo(LiveStats);
